"use client";

import { createContext, useContext, useEffect, useState } from "react";

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [cart, setCart] = useState(null);

  useEffect(() => {
    const isLocalStorageAvailable = typeof window.localStorage !== "undefined";

    if (isLocalStorageAvailable) {
      try {
        // Retrieve the x-wc-session from localStorage
        const sessionData = localStorage.getItem("x-wc-session");

        if (sessionData) {
          // Extract the expiration timestamp from the session data
          const parts = sessionData.split("%7C%7C");
          const expirationTime = parseInt(parts[2], 10);

          // Get the current Unix timestamp
          const currentTime = Math.floor(Date.now() / 1000);

          // Check if the session is expired
          if (currentTime > expirationTime) {
            // Session has expired, remove it from localStorage
            localStorage.removeItem("x-wc-session");
            console.log("Session expired and removed from localStorage");
          }
        }

        // Now, handle the cart data as usual
        const cartData = localStorage.getItem("next-cart");
        const cart = JSON.parse(cartData);
        if (cart) {
          setCart(cart);
        }
      } catch (error) {
        console.error("Error handling session or cart data:", error);
        localStorage.removeItem("next-cart");
        setCart(null);
      }
    }
  }, []);

  useEffect(() => {
    const saveCartToLocalStorage = () => {
      try {
        localStorage.setItem("next-cart", JSON.stringify(cart));
      } catch (error) {
        console.error("Failed to save cart data:", error);
      }
    };

    // Use pagehide to allow back/forward cache
    window.addEventListener("pagehide", saveCartToLocalStorage);

    return () => {
      window.removeEventListener("pagehide", saveCartToLocalStorage);
    };
  }, [cart]);

  return (
    <AppContext.Provider value={[cart, setCart]}>
      {children}
    </AppContext.Provider>
  );
};
